import { FC } from 'react';
import useTimerProgress from '@/features/poker-table/hooks/useTimerProgress';
import { twMerge } from 'tailwind-merge';

const colorClasses = {
  'ph-purple': 'border-ph-purple',
  'ph-green': 'border-ph-green',
  'ph-orange': 'border-ph-orange',
  'ph-red': 'border-ph-red',
};

interface TableHeaderTimeCounterProps {
  timer?: number;
  timeRemaining?: number;
  usingTimeBank?: boolean;
}
const TableHeaderTimeCounter: FC<TableHeaderTimeCounterProps> = ({ timer, timeRemaining, usingTimeBank }) => {
  const { progressColor } = useTimerProgress({
    timer,
    timeRemaining,
    usingTimeBank,
  });

  if (timer === undefined) {
    return null;
  }
  return (
    <div
      className={twMerge(
        'text-ph-violet mx-1 my-0 flex h-6 w-6 content-center items-center justify-center gap-0 rounded-full border-2 text-xs font-medium lg:h-8 lg:w-8',
        progressColor ? colorClasses[progressColor] : '',
      )}
    >
      {timeRemaining}
    </div>
  );
};

export default TableHeaderTimeCounter;
